import React from "react";
import "./Dashboard.css";

function SearchConfig() {
    return (
        <select className="searchSelectConfig" name="searchSelectConfig" id="searchSelectConfig" components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}>
            <option value="searchConfig">Search......</option>
        </select>
    );
}

export default SearchConfig;